export default "__VITE_ASSET__BEJ10Um5__"